import { memo } from 'react'

export const EntriesTimelineSkeleton = memo(function EntriesTimelineSkeleton() {
  return (
    <div className="space-y-4">
      <div className="bg-muted h-4 w-20 animate-pulse rounded" />
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className="flex items-start gap-2"
          style={{ animationDelay: `${i * 75}ms` }}
        >
          <div
            className="bg-muted h-5 w-5 animate-pulse rounded"
            style={{ animationDelay: `${i * 75}ms` }}
          />
          <div className="flex-1 space-y-1.5">
            <div
              className="bg-muted h-4 w-3/4 animate-pulse rounded"
              style={{ animationDelay: `${25 + i * 75}ms` }}
            />
            <div
              className="bg-muted h-3 w-1/4 animate-pulse rounded"
              style={{ animationDelay: `${50 + i * 75}ms` }}
            />
          </div>
        </div>
      ))}
    </div>
  )
})
